/**
 * Domain status component with verification button.
 */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { LoadingSpinner } from '@/components/ui/loading';
import { CheckCircle, XCircle, RefreshCw } from 'lucide-react';
import type { DomainResponse } from '@/api/schemas';
import { useDomainStatus } from '@/hooks/useDomains';
import './domain-status.scss';

export interface DomainStatusProps {
  domain: DomainResponse;
  onVerify: () => Promise<void>;
  isVerifying?: boolean;
}

export function DomainStatus({ domain, onVerify, isVerifying = false }: DomainStatusProps) {
  const { data: statusData, isLoading } = useDomainStatus(domain.domain_id);
  const isVerified = domain.verified_at !== null || statusData?.verified || false;

  return (
    <div className="domain-status">
      <div className="domain-status__badge">
        {isVerified ? (
          <>
            <CheckCircle className="domain-status__icon domain-status__icon--verified" />
            <span className="domain-status__text domain-status__text--verified">Verified</span>
          </>
        ) : (
          <>
            <XCircle className="domain-status__icon domain-status__icon--pending" />
            <span className="domain-status__text domain-status__text--pending">Pending</span>
          </>
        )}
      </div>
      {!isVerified && (
        <Button
          variant="primary"
          size="sm"
          onClick={onVerify}
          disabled={isVerifying || isLoading}
          className="domain-status__verify-button"
        >
          {isVerifying || isLoading ? (
            <>
              <LoadingSpinner size="sm" />
              Verifying...
            </>
          ) : (
            <>
              <RefreshCw />
              Verify DNS
            </>
          )}
        </Button>
      )}
    </div>
  );
}

